import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Router, Route } from '@angular/router';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';

@Injectable({
  providedIn: 'root'
})
export class MainSearchService extends BaseProvider {
	mainSearchIsVisible: boolean = false;
	isSearchingFromHome: boolean = false;
	isSearching: boolean = false;
	term: any;

	pages: any = 0;
	totalFound: any = 0;

  	constructor(  		
  		public router: Router,
		public globals: GlobalsService,
 		public http: HttpClient,	
 		public ls: LsHelperService,
  	) { 
		super();
		
		this.baseUrl = "mainSearch";		
	}	

	search(params){
		if(params.term=="") return;

		this.isSearching = true;

		this.term = params.term;
		
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + 

						'/page/' + this.page + 
						'/size/50' + 
						'?term=' + params.term;

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {				
			    	this.isSearching = false;	
			    	this.list = data.Data;

			    	this.pages = 0;
			    	this.totalFound = 0;

			    	if(this.list.length>0){
				    	this.totalFound = this.list[0].TotalRows;
				    	this.pages = this.list[0].TotalPages;
			    	}

					resolve(data.Data);
			    },
			    err => {
			    	this.isSearching = false;
			    	reject(err)
			    }
			);
		});    
	}    		

	gotoUrl(item){
		var url = "";

		this.clearSearch();

		if(item.ParentCategoryId){
			url = "/transaction-type/" + item.Id;
		}else{
			url = "/sub/" + item.CategoryId;
		}

		this.router.navigate([url]);
	}

	clearSearch(){
		this.mainSearchIsVisible = false;
		this.list = [];			
	}	
}
